import React, {useEffect, useState} from 'react';
import styles from "./ConfirmClientPopUp.module.css";
import Modal from "react-modal";
import {RequestStatus} from "../../../types/request";

interface WorkerRequestPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    workerRequestId: number | undefined;
    onConfirm: (status: RequestStatus, period?: number, rejectComment?: string) => void;
}

interface FormData {
    status: RequestStatus;
    period: number;
    comment: string;
}

//작업자 추가 요청 처리 팝업
const ConfirmWorkerRequestPopUp: React.FC<WorkerRequestPopUpProps> = ({
                                                                          isOpen,
                                                                          onClose,
                                                                          workerRequestId,
                                                                          onConfirm
                                                                      }) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [formData, setFormData] = useState<FormData>({
        status: RequestStatus.승인,
        period: 1,
        comment: ''
    });

    //초기값
    useEffect(() => {
        if (workerRequestId) {
            setFormData({
                status: RequestStatus.승인,
                period: 1,
                comment: ''
            });
        }
    }, [workerRequestId]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!workerRequestId) return;
        setIsSubmitting(true);

        try {
            onConfirm(
                formData.status,
                //승인 시 기간 선택
                formData.status === RequestStatus.승인 ? formData.period : undefined,
                //반려 시 반려 사유 작성
                formData.status === RequestStatus.반려 ? formData.comment : undefined
            );
            onClose();
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const showPeriodField = formData.status === RequestStatus.승인;
    const showCommentField = formData.status === RequestStatus.반려;
    const isSubmitDisabled = !workerRequestId ||
        isSubmitting ||
        (showCommentField && !formData.comment.trim()) ||
        (showPeriodField && (!formData.period || formData.period < 1));

    const handleStatusChange = (status: RequestStatus) => {
        setFormData(prev => ({
            ...prev,
            status: status,
            //반려 시 사유
            comment: status === RequestStatus.승인 ? '' : prev.comment
        }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>작업자 요청 처리</h2>
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label>처리 상태</label>
                        {/*승인, 반려, 대기 상태 선택 가능*/}
                        <select
                            value={formData.status}
                            onChange={(e) => handleStatusChange(e.target.value as RequestStatus)}
                            className={styles.select}
                            required
                            disabled={isSubmitting}
                        >
                            <option value={RequestStatus.승인}>승인</option>
                            <option value={RequestStatus.반려}>반려</option>
                            <option value={RequestStatus.대기}>대기</option>
                        </select>
                    </div>

                    {showPeriodField && (
                        <div className={styles.formGroup}>
                            {/*승인 시 기간 선택*/}
                            <label>계약 기간 (개월)</label>
                            <input
                                type="number"
                                value={formData.period === 0 ? '' : formData.period}
                                onChange={(e) => setFormData(prev => ({
                                    ...prev,
                                    period: Number(e.target.value)
                                }))}
                                className={styles.input}
                                min="1"
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    )}

                    {showCommentField && (
                        <div className={styles.formGroup}>
                            {/*반려 시 반려 사유 작성*/}
                            <label>반려 사유</label>
                            <textarea
                                value={formData.comment}
                                onChange={(e) => setFormData(prev => ({
                                    ...prev,
                                    comment: e.target.value
                                }))}
                                className={styles.textarea}
                                placeholder="반려 사유를 입력해주세요"
                                rows={8}
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    )}

                    {/*처리*/}
                    <button
                        type="submit"
                        className={styles.submitButton}
                        disabled={isSubmitDisabled}
                    >
                        {isSubmitting ? '처리 중...' : '처리'}
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default ConfirmWorkerRequestPopUp;